module.exports = __webpack_public_path__ + "media/theme/search-7a62f8d4.png";